// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interact-vid-sec {
  padding: 40px 15px 0px 70px;
}

.interact-vid-sec.pad {
  padding-bottom: 40px;
}

.interact-top-sec .interact-vid-sec {
  padding-bottom: 80px;
}

.interact-vid-head-sec {
  padding-top: 40px;
}

.interact-vid-head-sec .head-cols .col-info img {
  width: 30px;
  height: 30px;
  float: left;
  margin-right: 15px;
}

.interact-vid-head-sec > .container-fluid {
  max-width: 800px;
}

.interact-vid-head-sec .head-cols .col-info div h3 {
  font-size: 22px;
  font-weight: 600;
  color: #6e5eff;
}

.interact-vid-head-sec .head-cols .col-info div p {
  font-size: 14px;
}

.interact-vid-head-sec .head-vid h1 {
  font-size: 35px;
  margin-bottom: 3px;
}

.interact-vid-card {
  border: none;
  background-color: unset;
}

.interact-vid-card .media-body p.in {
  font-size: 14px;
}

.interact-vid-card .media-body h6 {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 60%;
}

.interact-vid-card .media-body p {
  font-size: 12px;
  margin-bottom: 0px;
}

.interact-vid-sec > h4 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
}

.interact-vid-sec > h4 a.view-all-btn {
  font-size: 15px;
  margin-left: 10px;
  font-weight: normal;
  color: #6e5eff;
}

/* .interact-slider-5 > .owl-nav{
    width: 100%
} */

.interact-slider > .owl-nav button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px !important;
  background-color: #000000b8 !important;
  color: #ffffff !important;
  outline: none;
  width: 35px;
}

.interact-slider > .owl-nav button:first-child {
  left: -34px;
}

.interact-slider > .owl-nav button:last-child {
  right: -34px;
}

.pop-Categories-slider > .owl-nav button {
  top: 68%;
}

.recommend-slider > .owl-nav button {
  top: 30%;
}

.start-slider .owl-nav button {
  top: 64%;
}

.start-slider > .owl-nav button:first-child {
  left: 0;
}

.start-slider > .owl-nav button:last-child {
  right: 0;
}

/* Top right image icontext */

.interact-cardimg-iconstext {
  background-color: #0000007d;
  width: 90px;
  border-radius: 2px;
  padding: 4px 8px;
  position: absolute;
  top: 0px;
  right: 0px;
}

.interact-cardimg-iconstext > span img {
  width: 16px !important;
  height: 16px;
  margin-right: 5px;
}

.interact-cardimg-iconstext > span b {
  color: #ffffff;
  font-size: 14px;
}

/* Top right image icontext */

.interact-slider-start .owl-stage {
  padding-left: 0px !important;
}

.interact-slider-start .item .media-body h5 {
  font-size: 16px;
  color: #6e5eff;
  margin-bottom: 0;
}

.interact-slider-start .item .media-body > span {
  color: lightgray;
  font-size: 14px;
}

.interact-slider-start .item .media-body > p {
  font-size: 15px;
  margin-bottom: 0;
}

.interact-slider-start .item .thumb-info p {
  font-size: 14px;
}

.interact-vid-start-sec .big-interact-card > img {
  object-fit: cover;
}

.interact-slider-start .item > .media {
  padding-left: 0px !important;
}

.interact-top-sec .top-interact-card .card > img {
  height: 160px;
  object-fit: cover;
}

.interact-slider-3 .owl-stage {
  padding-left: 0px !important;
}

.highly-interact-vid-sec .h-interact-item .h-txt {
  height: 100%;
  display: flex;
  align-content: space-between;
  flex-wrap: wrap;
  padding: 10px 10px 10px 20px;
  background: white;
}

.highly-interact-vid-sec .h-interact-item .h-vid > img {
  height: 200px;
  object-fit: cover;
}

.highly-interact-vid-sec .h-interact-item .h-txt h5 {
  font-size: 14px;
  font-weight: 600;
}

.highly-interact-vid-sec .h-interact-item .h-txt span {
  font-size: 12px;
  white-space: nowrap;
}

.highly-interact-vid-sec .h-interact-item .h-txt p {
  font-size: 12px;
  margin-bottom: 0px;
}

.highly-interact-vid-sec .h-interact-item .h-vid .media-body h6 {
  font-size: 14px;
  color: #ffffff;
}

.highly-interact-vid-sec .h-interact-item .h-vid .media-body p {
  font-size: 13px;
  color: #ffffff;
}

.highly-interact-vid-sec .h-interact-item .h-vid .media {
  padding: 0px 7px;
  position: absolute;
  left: 0px;
  bottom: 0px;
}

.highly-interact-vid-sec .h-interact-item .h-vid .media img {
  border: 1.5px solid white;
}

/* .highly-interact-vid-sec .h-interact-item .h-vid{
    height: 150px;
} */

.interact-vid-start-sec .big-interact-card .card-body {
  position: absolute;
  bottom: 5px;
  left: 20px;
  color: white;
}

.interact-vid-start-sec .big-interact-card .card-body .media img {
  border: 1.5px solid white;
}

/* Popular Categories section */

.pop-categories > .container-fluid > .row > div {
  padding: 0px;
  padding-right: 10px;
  /* height: 270px; */
}

.pop-categories > .container-fluid > .row > div:last-child {
  padding-right: 0px;
}

.interact-Popular-sec {
  background-color: #21175b;
}

.interact-Popular-sec .pop-categories .card {
  height: 230px;
  margin-bottom: 20px;
  border: none;
  background: none;
  transition: all 0.2s linear;
}

.interact-Popular-sec .pop-categories .card:hover {
  transform: scale(1.1);
  box-shadow: 1px 1px 10px 2px black;
  z-index: 1;
}

.pop-categories .card .card-img-overlay {
  color: #ffffff;
  top: unset;
  bottom: 0px;
  padding: 12px;
}

.pop-categories .card .card-img-overlay h6,
.pop-categories .card .card-img-overlay span {
  margin-bottom: 0px;
  font-size: 14px;
}

.pop-categories .card .card-img-overlay h3 {
  font-size: 24px;
}

.interact-Popular-sec .pop-categories .card > img {
  width: 100%;
  height: 100%;
}

.interact-Popular-sec .pop-categories {
  margin-bottom: 50px;
}

.interact-Popular-sec .interact-slider-5 .card .pop5 {
  height: 160px;
}

.interact-Popular-sec .interact-slider-5 .card-body {
  min-height: 85px;
}

.interact-Popular-sec .interact-slider-5 .card-body .media-body {
  color: #ffffff;
}

.interact-Popular-sec .interact-vid-sec > h4 {
  color: #ffffff;
}

.interact-Popular-sec .interact-slider-5 .card .pop5 > img {
  height: 100%;
  object-fit: cover;
}

/* Popular Categories section */

/* Popular Creators */

.pop-creat-sec .h-interact-item .h-txt {
  padding: 12px 20px 12px 12px;
  background: white;
}

.pop-creat-sec .h-interact-item .h-txt .media-body > span {
  color: lightgray;
}

.pop-creat-sec .h-interact-item .h-txt h6 {
  font-size: 15px;
  color: #6e5eff;
}

.pop-creat-sec .h-interact-item .h-txt .in {
  font-weight: 600;
}

/* Popular Creators */

/* Trending Videos section */

.interact-recommend-vid-sec .interact-vid-card > img,
.interact-slider-start .interact-vid-card > img {
  height: 160px;
  object-fit: cover;
}

/* Trending Videos section */

/* Today's Top Section */

.interact-top-sec .top-interact-card .card .top-body {
  padding: 10px 12px 15px 12px;
}

.top-interact-card .card .top-body .comment img,
.big-interact-card .top-body .comment img {
  width: 22px;
  height: 22px;
}

.top-interact-card .card .top-body h3,
.big-interact-card .top-body h3 {
  display: inline-block;
  background-color: #6e5eff;
  padding: 4px 8px;
  color: white;
  font-size: 20px;
}

.top-interact-card .card .top-body .comment span,
.big-interact-card .top-body .comment span {
  font-size: 14px;
  margin-left: 5px;
}

.big-interact-card .top-body .comment span {
  font-weight: 600;
}

.interact-top-sec .big-interact-card .top-body {
  position: absolute;
  top: 0px;
  left: 1px;
  display: flex;
  align-items: center;
}

.big-interact-card .top-body .comment {
  color: white;
  display: flex;
}

.interact-top-sec .top-interact-card .card .card-body {
  padding: 15px 0px 0px 0px;
  background: #f5f7f6;
}

img {
  cursor: pointer;
}

.todaysTop {
  background: #0000007d;
  border: 4px;
  padding: 5px;
  border-radius: 3px;
}

@media (max-width: 991px) {
  .interact-vid-sec {
    padding: 30px 30px 0px !important;
  }
  .custom-height,
  .position-relative.pop5 {
    height: auto !important;
    margin-bottom: 30px;
  }
  .card-body {
    padding-bottom: 20px !important;
  }
  .margin-right-0-mobile {
    margin-right: 0px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/beforeLogin/trending/trending.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,6BAA6B;;AAE7B;EACE,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,6BAA6B;;AAE7B;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;;AAE/B;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,+BAA+B;;AAE/B,qBAAqB;;AAErB;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB,4BAA4B;;AAE5B;;EAEE,aAAa;EACb,iBAAiB;AACnB;;AAEA,4BAA4B;;AAE5B,wBAAwB;;AAExB;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,iCAAiC;EACnC;EACA;;IAEE,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".interact-vid-sec {\r\n  padding: 40px 15px 0px 70px;\r\n}\r\n\r\n.interact-vid-sec.pad {\r\n  padding-bottom: 40px;\r\n}\r\n\r\n.interact-top-sec .interact-vid-sec {\r\n  padding-bottom: 80px;\r\n}\r\n\r\n.interact-vid-head-sec {\r\n  padding-top: 40px;\r\n}\r\n\r\n.interact-vid-head-sec .head-cols .col-info img {\r\n  width: 30px;\r\n  height: 30px;\r\n  float: left;\r\n  margin-right: 15px;\r\n}\r\n\r\n.interact-vid-head-sec > .container-fluid {\r\n  max-width: 800px;\r\n}\r\n\r\n.interact-vid-head-sec .head-cols .col-info div h3 {\r\n  font-size: 22px;\r\n  font-weight: 600;\r\n  color: #6e5eff;\r\n}\r\n\r\n.interact-vid-head-sec .head-cols .col-info div p {\r\n  font-size: 14px;\r\n}\r\n\r\n.interact-vid-head-sec .head-vid h1 {\r\n  font-size: 35px;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.interact-vid-card {\r\n  border: none;\r\n  background-color: unset;\r\n}\r\n\r\n.interact-vid-card .media-body p.in {\r\n  font-size: 14px;\r\n}\r\n\r\n.interact-vid-card .media-body h6 {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 60%;\r\n}\r\n\r\n.interact-vid-card .media-body p {\r\n  font-size: 12px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.interact-vid-sec > h4 {\r\n  margin-bottom: 20px;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n}\r\n\r\n.interact-vid-sec > h4 a.view-all-btn {\r\n  font-size: 15px;\r\n  margin-left: 10px;\r\n  font-weight: normal;\r\n  color: #6e5eff;\r\n}\r\n\r\n/* .interact-slider-5 > .owl-nav{\r\n    width: 100%\r\n} */\r\n\r\n.interact-slider > .owl-nav button {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 30px !important;\r\n  background-color: #000000b8 !important;\r\n  color: #ffffff !important;\r\n  outline: none;\r\n  width: 35px;\r\n}\r\n\r\n.interact-slider > .owl-nav button:first-child {\r\n  left: -34px;\r\n}\r\n\r\n.interact-slider > .owl-nav button:last-child {\r\n  right: -34px;\r\n}\r\n\r\n.pop-Categories-slider > .owl-nav button {\r\n  top: 68%;\r\n}\r\n\r\n.recommend-slider > .owl-nav button {\r\n  top: 30%;\r\n}\r\n\r\n.start-slider .owl-nav button {\r\n  top: 64%;\r\n}\r\n\r\n.start-slider > .owl-nav button:first-child {\r\n  left: 0;\r\n}\r\n\r\n.start-slider > .owl-nav button:last-child {\r\n  right: 0;\r\n}\r\n\r\n/* Top right image icontext */\r\n\r\n.interact-cardimg-iconstext {\r\n  background-color: #0000007d;\r\n  width: 90px;\r\n  border-radius: 2px;\r\n  padding: 4px 8px;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span img {\r\n  width: 16px !important;\r\n  height: 16px;\r\n  margin-right: 5px;\r\n}\r\n\r\n.interact-cardimg-iconstext > span b {\r\n  color: #ffffff;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Top right image icontext */\r\n\r\n.interact-slider-start .owl-stage {\r\n  padding-left: 0px !important;\r\n}\r\n\r\n.interact-slider-start .item .media-body h5 {\r\n  font-size: 16px;\r\n  color: #6e5eff;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.interact-slider-start .item .media-body > span {\r\n  color: lightgray;\r\n  font-size: 14px;\r\n}\r\n\r\n.interact-slider-start .item .media-body > p {\r\n  font-size: 15px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.interact-slider-start .item .thumb-info p {\r\n  font-size: 14px;\r\n}\r\n\r\n.interact-vid-start-sec .big-interact-card > img {\r\n  object-fit: cover;\r\n}\r\n\r\n.interact-slider-start .item > .media {\r\n  padding-left: 0px !important;\r\n}\r\n\r\n.interact-top-sec .top-interact-card .card > img {\r\n  height: 160px;\r\n  object-fit: cover;\r\n}\r\n\r\n.interact-slider-3 .owl-stage {\r\n  padding-left: 0px !important;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-txt {\r\n  height: 100%;\r\n  display: flex;\r\n  align-content: space-between;\r\n  flex-wrap: wrap;\r\n  padding: 10px 10px 10px 20px;\r\n  background: white;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-vid > img {\r\n  height: 200px;\r\n  object-fit: cover;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-txt h5 {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-txt span {\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-txt p {\r\n  font-size: 12px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-vid .media-body h6 {\r\n  font-size: 14px;\r\n  color: #ffffff;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-vid .media-body p {\r\n  font-size: 13px;\r\n  color: #ffffff;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-vid .media {\r\n  padding: 0px 7px;\r\n  position: absolute;\r\n  left: 0px;\r\n  bottom: 0px;\r\n}\r\n\r\n.highly-interact-vid-sec .h-interact-item .h-vid .media img {\r\n  border: 1.5px solid white;\r\n}\r\n\r\n/* .highly-interact-vid-sec .h-interact-item .h-vid{\r\n    height: 150px;\r\n} */\r\n\r\n.interact-vid-start-sec .big-interact-card .card-body {\r\n  position: absolute;\r\n  bottom: 5px;\r\n  left: 20px;\r\n  color: white;\r\n}\r\n\r\n.interact-vid-start-sec .big-interact-card .card-body .media img {\r\n  border: 1.5px solid white;\r\n}\r\n\r\n/* Popular Categories section */\r\n\r\n.pop-categories > .container-fluid > .row > div {\r\n  padding: 0px;\r\n  padding-right: 10px;\r\n  /* height: 270px; */\r\n}\r\n\r\n.pop-categories > .container-fluid > .row > div:last-child {\r\n  padding-right: 0px;\r\n}\r\n\r\n.interact-Popular-sec {\r\n  background-color: #21175b;\r\n}\r\n\r\n.interact-Popular-sec .pop-categories .card {\r\n  height: 230px;\r\n  margin-bottom: 20px;\r\n  border: none;\r\n  background: none;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.interact-Popular-sec .pop-categories .card:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 1px 1px 10px 2px black;\r\n  z-index: 1;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay {\r\n  color: #ffffff;\r\n  top: unset;\r\n  bottom: 0px;\r\n  padding: 12px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h6,\r\n.pop-categories .card .card-img-overlay span {\r\n  margin-bottom: 0px;\r\n  font-size: 14px;\r\n}\r\n\r\n.pop-categories .card .card-img-overlay h3 {\r\n  font-size: 24px;\r\n}\r\n\r\n.interact-Popular-sec .pop-categories .card > img {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.interact-Popular-sec .pop-categories {\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.interact-Popular-sec .interact-slider-5 .card .pop5 {\r\n  height: 160px;\r\n}\r\n\r\n.interact-Popular-sec .interact-slider-5 .card-body {\r\n  min-height: 85px;\r\n}\r\n\r\n.interact-Popular-sec .interact-slider-5 .card-body .media-body {\r\n  color: #ffffff;\r\n}\r\n\r\n.interact-Popular-sec .interact-vid-sec > h4 {\r\n  color: #ffffff;\r\n}\r\n\r\n.interact-Popular-sec .interact-slider-5 .card .pop5 > img {\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Popular Categories section */\r\n\r\n/* Popular Creators */\r\n\r\n.pop-creat-sec .h-interact-item .h-txt {\r\n  padding: 12px 20px 12px 12px;\r\n  background: white;\r\n}\r\n\r\n.pop-creat-sec .h-interact-item .h-txt .media-body > span {\r\n  color: lightgray;\r\n}\r\n\r\n.pop-creat-sec .h-interact-item .h-txt h6 {\r\n  font-size: 15px;\r\n  color: #6e5eff;\r\n}\r\n\r\n.pop-creat-sec .h-interact-item .h-txt .in {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Popular Creators */\r\n\r\n/* Trending Videos section */\r\n\r\n.interact-recommend-vid-sec .interact-vid-card > img,\r\n.interact-slider-start .interact-vid-card > img {\r\n  height: 160px;\r\n  object-fit: cover;\r\n}\r\n\r\n/* Trending Videos section */\r\n\r\n/* Today's Top Section */\r\n\r\n.interact-top-sec .top-interact-card .card .top-body {\r\n  padding: 10px 12px 15px 12px;\r\n}\r\n\r\n.top-interact-card .card .top-body .comment img,\r\n.big-interact-card .top-body .comment img {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.top-interact-card .card .top-body h3,\r\n.big-interact-card .top-body h3 {\r\n  display: inline-block;\r\n  background-color: #6e5eff;\r\n  padding: 4px 8px;\r\n  color: white;\r\n  font-size: 20px;\r\n}\r\n\r\n.top-interact-card .card .top-body .comment span,\r\n.big-interact-card .top-body .comment span {\r\n  font-size: 14px;\r\n  margin-left: 5px;\r\n}\r\n\r\n.big-interact-card .top-body .comment span {\r\n  font-weight: 600;\r\n}\r\n\r\n.interact-top-sec .big-interact-card .top-body {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 1px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.big-interact-card .top-body .comment {\r\n  color: white;\r\n  display: flex;\r\n}\r\n\r\n.interact-top-sec .top-interact-card .card .card-body {\r\n  padding: 15px 0px 0px 0px;\r\n  background: #f5f7f6;\r\n}\r\n\r\nimg {\r\n  cursor: pointer;\r\n}\r\n\r\n.todaysTop {\r\n  background: #0000007d;\r\n  border: 4px;\r\n  padding: 5px;\r\n  border-radius: 3px;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .interact-vid-sec {\r\n    padding: 30px 30px 0px !important;\r\n  }\r\n  .custom-height,\r\n  .position-relative.pop5 {\r\n    height: auto !important;\r\n    margin-bottom: 30px;\r\n  }\r\n  .card-body {\r\n    padding-bottom: 20px !important;\r\n  }\r\n  .margin-right-0-mobile {\r\n    margin-right: 0px !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
